import React, { useRef, useState, useEffect } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Select from 'react-select';
import { Row, Col, FormGroup } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { uniqBy } from 'lodash';
import { useTranslation } from 'react-i18next';
import { months, getYears, colourWayOptions, customStyles } from '../../helper';
import CustomTooltip from '../../Tooltip/CustomTooltip';
import { CurrentYearOption } from '../CurrentYearDropdown';

function FilterBy({
  onBtnClick,
  placeholder,
  noOption,
  placeholder2,
  noOption2,
  placeholder3,
  noOption3,
  placeholder4,
  noOption4,
  placeholder5,
  noOption5,
  placeholder6,
  noOption6,
  placeholder7,
  noOption7,
  placeholder8,
  noOption8,
  placeholder9,
  noOption9,
  placeholder10,
  noOption10,
  selectedItem1,
  selectedItem2,
  selectedItem3,
  selectedItem4,
  selectedItem5,
  selectedItem6,
  selectedItem7,
  selectedItem8,
  selectedItem9,
  selectedItem10,
  isDisable,
  newVisual,
  colourwayPlaceholder,
  colourwayNoOption,
  colourRefPlaceholder,
  colourRefNoOption,
  selectedColourWay,
  selectedColour,
}) {
  const triggerRef = useRef(null);
  const containerRef = useRef(null);
  const ProductTestingData = useSelector((redState) => redState);
  const { Measuremets, SystemMastersDetails, SuppliersDetails } = ProductTestingData;
  const { ProductColourList } = Measuremets;
  const { brandList, seasonList, productStatusList, category1List, category2List, category3List, category4List, testTypeMaster } = SystemMastersDetails;
  const { tier2AndAboveList, tier1List } = SuppliersDetails;
  const { t } = useTranslation('common');
  const [supplierOptions, setSupplierOptions] = useState([]);
  const selectBrand = 'Select Brand';
  const selectSeason = 'Select Season';
  useEffect(() => {
    const suppArray = [...tier1List, ...tier2AndAboveList];
    const upnewArr = uniqBy(suppArray, (e) => e._id);
    setSupplierOptions([...upnewArr]);
  }, [tier2AndAboveList, tier1List]);

  return (
    <div ref={containerRef} className={placeholder.includes('Brand') ? 'modified-popOver-test-lib' : 'modified-popOver'}>
      <CustomTooltip placement="top" tooltipText={t('FILTER_BUTTON.FILTER')}>
        <button
          type="button"
          className={`${newVisual ? 'btn btn-outline common-btn' : 'filter-btn product-bom-icon ml-0 filter-button_add_colour_group'}`}
          disabled={isDisable}
        >
          <OverlayTrigger
            placement={t('FILTER_BUTTON.BUTTON')}
            trigger="click"
            rootClose
            container={containerRef}
            target={triggerRef}
            overlay={
              <Popover className="custom-popover">
                <Popover.Content>
                  <Row className="form-row">
                    <Col md={4}>
                      <FormGroup>
                        <div className="mb-0 common-react-select">
                          <Select
                            isClearable
                            options={placeholder.includes(selectBrand) ? brandList : testTypeMaster}
                            getOptionLabel={(opt) => `${opt.name}`}
                            getOptionValue={(opt) => `${opt._id}`}
                            onChange={(e) => onBtnClick('op1', e)}
                            styles={customStyles}
                            value={selectedItem1}
                            placeholder={placeholder}
                            noOptionsMessage={() => noOption}
                            className="common-select"
                            classNamePrefix="common-select"
                          />
                        </div>
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <div className="mb-0 common-react-select">
                          <Select
                            isClearable
                            options={placeholder2.includes(selectSeason) ? seasonList : colourWayOptions(ProductColourList)}
                            getOptionLabel={(option2) => `${option2.name}`}
                            getOptionValue={(option2) => `${option2._id}`}
                            onChange={(event) => onBtnClick('op2', event)}
                            styles={customStyles}
                            value={selectedItem2}
                            placeholder={placeholder2}
                            noOptionsMessage={() => noOption2}
                            className="common-select"
                            classNamePrefix="common-select"
                          />
                        </div>
                      </FormGroup>
                    </Col>

                    {placeholder6 && noOption6 && (
                      <Col md={4}>
                        <FormGroup>
                          <div className="mb-0 common-react-select">
                            <Select
                              isClearable
                              options={productStatusList}
                              getOptionLabel={(option6) => `${option6.name}`}
                              getOptionValue={(option6) => `${option6._id}`}
                              onChange={(event) => onBtnClick('op6', event)}
                              styles={customStyles}
                              value={selectedItem6}
                              placeholder={placeholder6}
                              noOptionsMessage={() => noOption6}
                              className="common-select"
                              classNamePrefix="common-select"
                            />
                          </div>
                        </FormGroup>
                      </Col>
                    )}

                    {placeholder3 && noOption3 && (
                      <Col md={4}>
                        <FormGroup>
                          <div className="mb-0 common-react-select">
                            <Select
                              components={{ Option: CurrentYearOption }}
                              isClearable
                              options={getYears()}
                              getOptionLabel={(option3) => `${option3.name}`}
                              getOptionValue={(option3) => `${option3._id}`}
                              onChange={(event) => onBtnClick('op3', event)}
                              styles={customStyles}
                              value={selectedItem3}
                              placeholder={placeholder3}
                              noOptionsMessage={() => noOption3}
                              className="common-select"
                              classNamePrefix="common-select"
                            />
                          </div>
                        </FormGroup>
                      </Col>
                    )}
                    {placeholder4 && noOption4 && (
                      <Col md={4}>
                        <FormGroup>
                          <div className="mb-0 common-react-select">
                            {' '}
                            <Select
                              isClearable
                              options={months}
                              getOptionLabel={(option4) => `${option4.name}`}
                              getOptionValue={(option4) => `${option4._id}`}
                              onChange={(e) => onBtnClick('op4', e)}
                              styles={customStyles}
                              value={selectedItem4}
                              placeholder={placeholder4}
                              noOptionsMessage={() => noOption4}
                              className="common-select"
                              classNamePrefix="common-select"
                            />
                          </div>
                        </FormGroup>
                      </Col>
                    )}
                    {placeholder5 && noOption5 && (
                      <Col md={4}>
                        <FormGroup>
                          <div className="mb-0 common-react-select">
                            {' '}
                            <Select
                              isClearable
                              options={supplierOptions}
                              getOptionLabel={(option5) => `${option5.name}`}
                              getOptionValue={(option5) => `${option5._id}`}
                              onChange={(event) => onBtnClick('op5', event)}
                              styles={customStyles}
                              value={selectedItem5}
                              placeholder={placeholder5}
                              noOptionsMessage={() => noOption5}
                              className="common-select"
                              classNamePrefix="common-select"
                            />
                          </div>
                        </FormGroup>
                      </Col>
                    )}

                    {placeholder7 && noOption7 && (
                      <Col md={4}>
                        <FormGroup>
                          <div className="mb-0 common-react-select">
                            {' '}
                            <Select
                              isClearable
                              options={category1List}
                              getOptionLabel={(option7) => `${option7.name}`}
                              getOptionValue={(option7) => `${option7._id}`}
                              onChange={(event) => onBtnClick('op7', event)}
                              styles={customStyles}
                              value={selectedItem7}
                              placeholder={placeholder7}
                              noOptionsMessage={() => noOption7}
                              className="common-select"
                              classNamePrefix="common-select"
                            />
                          </div>
                        </FormGroup>
                      </Col>
                    )}
                    {placeholder8 && noOption8 && (
                      <Col md={4}>
                        <FormGroup>
                          <div className="mb-0 common-react-select">
                            {' '}
                            <Select
                              isClearable
                              options={category2List}
                              getOptionLabel={(option8) => `${option8.name}`}
                              getOptionValue={(option8) => `${option8._id}`}
                              onChange={(e) => onBtnClick('op8', e)}
                              styles={customStyles}
                              value={selectedItem8}
                              placeholder={placeholder8}
                              noOptionsMessage={() => noOption8}
                              className="common-select"
                              classNamePrefix="common-select"
                            />
                          </div>
                        </FormGroup>
                      </Col>
                    )}
                    {placeholder9 && noOption9 && (
                      <Col md={4}>
                        <FormGroup>
                          <div className="mb-0 common-react-select">
                            {' '}
                            <Select
                              isClearable
                              options={category3List.length > 0 ? category3List : [{ name: t('FILTER_BUTTON.NOT_AVAILABLE') }]}
                              getOptionLabel={(option9) => `${option9.name}`}
                              getOptionValue={(option9) => `${option9._id}`}
                              onChange={(event) => onBtnClick('op9', event)}
                              styles={customStyles}
                              value={selectedItem9}
                              placeholder={placeholder9}
                              noOptionsMessage={() => noOption9}
                              className="common-select"
                              classNamePrefix="common-select"
                            />
                          </div>
                        </FormGroup>
                      </Col>
                    )}
                    {placeholder10 && noOption10 && (
                      <Col md={4}>
                        <FormGroup>
                          <div className="mb-0 common-react-select">
                            {' '}
                            <Select
                              isClearable
                              options={category4List.length > 0 ? category4List : [{ name: t('FILTER_BUTTON.NOT_AVAILABLE') }]}
                              getOptionLabel={(option10) => `${option10.name}`}
                              getOptionValue={(option10) => `${option10._id}`}
                              onChange={(event) => onBtnClick('op10', event)}
                              styles={customStyles}
                              value={selectedItem10}
                              placeholder={placeholder10}
                              noOptionsMessage={() => noOption10}
                              className="common-select"
                              classNamePrefix="common-select"
                            />
                          </div>
                        </FormGroup>
                      </Col>
                    )}
                    {colourwayPlaceholder && colourwayNoOption && (
                      <Col md={4}>
                        <FormGroup>
                          <div className="mb-0 common-react-select">
                            {' '}
                            <Select
                              isClearable
                              options={ProductColourList.length > 0 ? colourWayOptions(ProductColourList) : [{ name: t('FILTER_BUTTON.NOT_AVAILABLE') }]}
                              getOptionLabel={(option11) => `${option11.name}`}
                              getOptionValue={(option11) => `${option11._id}`}
                              onChange={(event) => onBtnClick('op11', event)}
                              styles={customStyles}
                              value={selectedColourWay}
                              placeholder={colourwayPlaceholder}
                              noOptionsMessage={() => colourwayNoOption}
                              className="common-select"
                              classNamePrefix="common-select"
                            />
                          </div>
                        </FormGroup>
                      </Col>
                    )}
                    {colourRefPlaceholder && colourRefNoOption && (
                      <Col md={4}>
                        <FormGroup>
                          <div className="mb-0 common-react-select">
                            {' '}
                            <Select
                              isClearable
                              options={ProductColourList.length > 0 ? colourWayOptions(ProductColourList) : [{ name: t('FILTER_BUTTON.NOT_AVAILABLE') }]}
                              getOptionLabel={(option12) => `${option12.name}`}
                              getOptionValue={(option12) => `${option12._id}`}
                              onChange={(event) => onBtnClick('op12', event)}
                              styles={customStyles}
                              value={selectedColour}
                              placeholder={colourRefPlaceholder}
                              noOptionsMessage={() => colourRefNoOption}
                              className="common-select"
                              classNamePrefix="common-select"
                            />
                          </div>
                        </FormGroup>
                      </Col>
                    )}
                  </Row>
                  <Row>
                    <Col md={12}>
                      <div className="d-flex  justify-content-end">
                        <CustomTooltip placement="top" tooltipText={t('FILTER_BUTTON.CLEAR')}>
                          <button aria-label="clear" type="button" onClick={() => onBtnClick('clear')} id="Clear" className="btn d-inline-flex p-0">
                            <i className="icon-Clear-New f-24" />
                          </button>
                        </CustomTooltip>
                        <CustomTooltip placement="top" tooltipText={t('FILTER_BUTTON.APPLY')}>
                          <button aria-label="apply" type="submit" onClick={() => onBtnClick()} id="Apply" className="btn d-inline-flex ml-16 p-0">
                            <i className="icon-Tick-1 f-28" />
                          </button>
                        </CustomTooltip>
                      </div>
                    </Col>
                  </Row>
                </Popover.Content>
              </Popover>
            }
          >
            <i className="icon-Filter f-26" />
          </OverlayTrigger>
          {!newVisual && <span className="text-icon">{t('FILTER_BUTTON.FILTER')}</span>}
        </button>
      </CustomTooltip>
    </div>
  );
}

export default FilterBy;
